import { render, staticRenderFns } from "./keyword-dedup-list.component.html?vue&type=template&id=839b3982&scoped=true&external"
import script from "./keyword-dedup-list.component.vue?vue&type=script&lang=ts"
export * from "./keyword-dedup-list.component.vue?vue&type=script&lang=ts"
import style0 from "./keyword-dedup-list.component.css?vue&type=style&index=0&id=839b3982&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839b3982",
  null
  
)

export default component.exports